module.exports = "<div class=\"custom-timer\" ng-style=\"{'opacity' : showTimer ? '0.8' : '0'}\">\n\t<i class=\"mdi mdi-alert-triangle\"></i> {{timer}}\n</div>\n\n<style type=\"text/css\">\n\t.custom-timer {\n  \tposition: absolute;\n  \ttop: 40px;\n  \tright: 50px;\n  \tbackground-position: 15px center;\n  \tbackground-repeat: no-repeat;\n  \tbox-shadow: 0 0 12px #999999;\n  \tcolor: #FFFFFF;\n  \tpadding: 25px;\n  \tbackground-color: #F89406;\n  \tfont-size: 20px;\n  \ttransition: all 1s ease-in-out;\n\t}\n</style>"


//////////////////
// WEBPACK FOOTER
// ./client/app/borne/timer.html
// module id = 271
// module chunks = 0